import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  cardPanel,
  cardInput,
} from 'shared/styles/commonStyles';


export const SwitchCardWrapper = styled.div`
  width: ${(p) => p.$w || '100%'};
  height: ${(p) => p.$h || '355.2px'};
  ${cardPanel}
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  padding: 16.8px;
  position: relative;
  overflow: hidden;

  ${(p) =>
    p.$watermark &&
    css`
      &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 112px;
        height: 112px;
        background-image: url(${p.$watermark});
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 0.06;
        pointer-events: none;
        z-index: 0;
      }
    `}

  ${(p) =>
    p.$messageBoxOpen &&
    css`
      position: relative;
    `}

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;


export const SwitchCardTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--switch-text-secondary);
  text-transform: capitalize;
  position: relative;
  z-index: 1;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
    `}
`;


export const SwitchSectionTop = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 16px;
  position: relative;
  z-index: 1;
`;


export const SwitchFormController = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  margin-top: auto;
  position: relative;
  z-index: 1;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
    `}
`;


export const SwitchInputSection = styled.section`
  width: 100%;
  ${flexBoxCenter}
`;


export const SwitchInputTemp = styled.input`
  width: ${(p) => p.$w || '100%'};
  height: 40px;
  ${cardInput}
  border-radius: 9999px;
  box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.8);
  padding: 8px 16px;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--switch-text-secondary);
  text-align: center;

  &::placeholder {
    color: var(--switch-text-muted);
  }

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
    `}
`;


export const SwitchButtonSection = styled.section`
  width: 100%;
  ${flexBoxCenter}
`;
